module.exports = __webpack_public_path__ + "img/photo-44.9f2919bd.webp";